var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
export const AddExamPreparationWorkRequestExamTypeEnum = {
    Preset: 'PRESET',
    Custom: 'CUSTOM'
};
export const Award = {
    Gold: 'GOLD',
    Silver: 'SILVER',
    Bronze: 'BRONZE',
    None: 'NONE'
};
export const CorrectAnswerRateType = {
    Basic: 'BASIC',
    LevelupDrill: 'LEVELUP_DRILL'
};
export const DrillType = {
    Kokugo: 'KOKUGO',
    Sansu: 'SANSU',
    Rika: 'RIKA',
    Shakai: 'SHAKAI',
    Kanji: 'KANJI',
    Endrill: 'ENDRILL',
    Enwork: 'ENWORK',
    Kana: 'KANA',
    ChugakuKokugo: 'CHUGAKU_KOKUGO',
    ChugakuSugaku: 'CHUGAKU_SUGAKU',
    ChugakuEndrill: 'CHUGAKU_ENDRILL',
    ChugakuRika: 'CHUGAKU_RIKA',
    ChugakuChiri: 'CHUGAKU_CHIRI',
    ChugakuRekishi: 'CHUGAKU_REKISHI',
    ChugakuKoumin: 'CHUGAKU_KOUMIN',
    ChugakuGijutsu: 'CHUGAKU_GIJUTSU',
    ChugakuKatei: 'CHUGAKU_KATEI',
    ChugakuHotai: 'CHUGAKU_HOTAI',
    ChugakuOngaku: 'CHUGAKU_ONGAKU',
    ChugakuBijutsu: 'CHUGAKU_BIJUTSU',
    ChugakuReviewKokugo: 'CHUGAKU_REVIEW_KOKUGO',
    ChugakuReviewSansu: 'CHUGAKU_REVIEW_SANSU',
    Nihongo: 'NIHONGO'
};
export const FileSort = {
    CreateDatetime: 'CREATE_DATETIME',
    UpdateDatetime: 'UPDATE_DATETIME',
    Name: 'NAME'
};
export const LearningAmountType = {
    Basic: 'BASIC',
    LevelupDrill: 'LEVELUP_DRILL',
    Work: 'WORK'
};
export const Order = {
    Asc: 'ASC',
    Desc: 'DESC'
};
export const Phase = {
    FirstTimeStart: 'FIRST_TIME_START',
    FirstTimeToLastCompleted: 'FIRST_TIME_TO_LAST_COMPLETED',
    FirstTimeWithClose: 'FIRST_TIME_WITH_CLOSE',
    MistakeStart: 'MISTAKE_START',
    MistakeToLastCompletes: 'MISTAKE_TO_LAST_COMPLETES',
    MistakeWithClose: 'MISTAKE_WITH_CLOSE'
};
export const ResponseType = {
    ForTeacher: 'ForTeacher',
    ForStudent: 'ForStudent'
};
export const WorkType = {
    Personal: 'PERSONAL',
    Original: 'ORIGINAL',
    Assignment: 'ASSIGNMENT'
};
export const AssignmentWorkControllerApiAxiosParamCreator = function (configuration) {
    return {
        createMyAssignmentWork: (originWorkId_1, ...args_1) => __awaiter(this, [originWorkId_1, ...args_1], void 0, function* (originWorkId, options = {}) {
            assertParamExists('createMyAssignmentWork', 'originWorkId', originWorkId);
            const localVarPath = `/drillweb/work/assignment`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (originWorkId !== undefined) {
                localVarQueryParameter['originWorkId'] = originWorkId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getAssignmentWorks: (assignmentId_1, ...args_1) => __awaiter(this, [assignmentId_1, ...args_1], void 0, function* (assignmentId, options = {}) {
            assertParamExists('getAssignmentWorks', 'assignmentId', assignmentId);
            const localVarPath = `/drillweb/work/assignment/{assignmentId}`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getWorkEffortByOriginWorkId: (originWorkId_1, userIds_1, onlyFirst_1, ...args_1) => __awaiter(this, [originWorkId_1, userIds_1, onlyFirst_1, ...args_1], void 0, function* (originWorkId, userIds, onlyFirst, options = {}) {
            assertParamExists('getWorkEffortByOriginWorkId', 'originWorkId', originWorkId);
            assertParamExists('getWorkEffortByOriginWorkId', 'userIds', userIds);
            assertParamExists('getWorkEffortByOriginWorkId', 'onlyFirst', onlyFirst);
            const localVarPath = `/drillweb/work/assignment/effort`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (originWorkId !== undefined) {
                localVarQueryParameter['originWorkId'] = originWorkId;
            }
            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }
            if (onlyFirst !== undefined) {
                localVarQueryParameter['onlyFirst'] = onlyFirst;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const AssignmentWorkControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AssignmentWorkControllerApiAxiosParamCreator(configuration);
    return {
        createMyAssignmentWork(originWorkId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createMyAssignmentWork(originWorkId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AssignmentWorkControllerApi.createMyAssignmentWork']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getAssignmentWorks(assignmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAssignmentWorks(assignmentId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AssignmentWorkControllerApi.getAssignmentWorks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getWorkEffortByOriginWorkId(originWorkId, userIds, onlyFirst, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkEffortByOriginWorkId(originWorkId, userIds, onlyFirst, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AssignmentWorkControllerApi.getWorkEffortByOriginWorkId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const AssignmentWorkControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AssignmentWorkControllerApiFp(configuration);
    return {
        createMyAssignmentWork(originWorkId, options) {
            return localVarFp.createMyAssignmentWork(originWorkId, options).then((request) => request(axios, basePath));
        },
        getAssignmentWorks(assignmentId, options) {
            return localVarFp.getAssignmentWorks(assignmentId, options).then((request) => request(axios, basePath));
        },
        getWorkEffortByOriginWorkId(originWorkId, userIds, onlyFirst, options) {
            return localVarFp.getWorkEffortByOriginWorkId(originWorkId, userIds, onlyFirst, options).then((request) => request(axios, basePath));
        },
    };
};
export class AssignmentWorkControllerApi extends BaseAPI {
    createMyAssignmentWork(originWorkId, options) {
        return AssignmentWorkControllerApiFp(this.configuration).createMyAssignmentWork(originWorkId, options).then((request) => request(this.axios, this.basePath));
    }
    getAssignmentWorks(assignmentId, options) {
        return AssignmentWorkControllerApiFp(this.configuration).getAssignmentWorks(assignmentId, options).then((request) => request(this.axios, this.basePath));
    }
    getWorkEffortByOriginWorkId(originWorkId, userIds, onlyFirst, options) {
        return AssignmentWorkControllerApiFp(this.configuration).getWorkEffortByOriginWorkId(originWorkId, userIds, onlyFirst, options).then((request) => request(this.axios, this.basePath));
    }
}
export const DrillHistoryControllerApiAxiosParamCreator = function (configuration) {
    return {
        getDrillHistory: (getDrillHistoriesRequest_1, ...args_1) => __awaiter(this, [getDrillHistoriesRequest_1, ...args_1], void 0, function* (getDrillHistoriesRequest, options = {}) {
            assertParamExists('getDrillHistory', 'getDrillHistoriesRequest', getDrillHistoriesRequest);
            const localVarPath = `/drillweb/history/drillHistory`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getDrillHistoriesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getDrillHistory1: (ids_1, ...args_1) => __awaiter(this, [ids_1, ...args_1], void 0, function* (ids, options = {}) {
            assertParamExists('getDrillHistory1', 'ids', ids);
            const localVarPath = `/drillweb/history/drillHistory/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const DrillHistoryControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = DrillHistoryControllerApiAxiosParamCreator(configuration);
    return {
        getDrillHistory(getDrillHistoriesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDrillHistory(getDrillHistoriesRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DrillHistoryControllerApi.getDrillHistory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getDrillHistory1(ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDrillHistory1(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DrillHistoryControllerApi.getDrillHistory1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const DrillHistoryControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DrillHistoryControllerApiFp(configuration);
    return {
        getDrillHistory(getDrillHistoriesRequest, options) {
            return localVarFp.getDrillHistory(getDrillHistoriesRequest, options).then((request) => request(axios, basePath));
        },
        getDrillHistory1(ids, options) {
            return localVarFp.getDrillHistory1(ids, options).then((request) => request(axios, basePath));
        },
    };
};
export class DrillHistoryControllerApi extends BaseAPI {
    getDrillHistory(getDrillHistoriesRequest, options) {
        return DrillHistoryControllerApiFp(this.configuration).getDrillHistory(getDrillHistoriesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    getDrillHistory1(ids, options) {
        return DrillHistoryControllerApiFp(this.configuration).getDrillHistory1(ids, options).then((request) => request(this.axios, this.basePath));
    }
}
export const LearningHistoryControllerApiAxiosParamCreator = function (configuration) {
    return {
        getAllUnitCorrectAnswerRates: (drillType_1, courseId_1, organizationId_1, correctAnswerRateType_1, ...args_1) => __awaiter(this, [drillType_1, courseId_1, organizationId_1, correctAnswerRateType_1, ...args_1], void 0, function* (drillType, courseId, organizationId, correctAnswerRateType, options = {}) {
            assertParamExists('getAllUnitCorrectAnswerRates', 'drillType', drillType);
            assertParamExists('getAllUnitCorrectAnswerRates', 'courseId', courseId);
            assertParamExists('getAllUnitCorrectAnswerRates', 'organizationId', organizationId);
            assertParamExists('getAllUnitCorrectAnswerRates', 'correctAnswerRateType', correctAnswerRateType);
            const localVarPath = `/drillweb/learning-history/correct-answer-rate/courses/{courseId}/units`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (correctAnswerRateType !== undefined) {
                localVarQueryParameter['correctAnswerRateType'] = correctAnswerRateType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getAllUnitsGradeCorrectAnswerRates: (drillType_1, courseId_1, grade_1, correctAnswerRateType_1, ...args_1) => __awaiter(this, [drillType_1, courseId_1, grade_1, correctAnswerRateType_1, ...args_1], void 0, function* (drillType, courseId, grade, correctAnswerRateType, options = {}) {
            assertParamExists('getAllUnitsGradeCorrectAnswerRates', 'drillType', drillType);
            assertParamExists('getAllUnitsGradeCorrectAnswerRates', 'courseId', courseId);
            assertParamExists('getAllUnitsGradeCorrectAnswerRates', 'grade', grade);
            assertParamExists('getAllUnitsGradeCorrectAnswerRates', 'correctAnswerRateType', correctAnswerRateType);
            const localVarPath = `/drillweb/learning-history/grade-correct-answer-avg-rate/courses/{courseId}/units`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (grade !== undefined) {
                localVarQueryParameter['grade'] = grade;
            }
            if (correctAnswerRateType !== undefined) {
                localVarQueryParameter['correctAnswerRateType'] = correctAnswerRateType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getMonthlyCoreSubjectsLearningAmount: (userId_1, fiscalYear_1, ...args_1) => __awaiter(this, [userId_1, fiscalYear_1, ...args_1], void 0, function* (userId, fiscalYear, options = {}) {
            assertParamExists('getMonthlyCoreSubjectsLearningAmount', 'userId', userId);
            assertParamExists('getMonthlyCoreSubjectsLearningAmount', 'fiscalYear', fiscalYear);
            const localVarPath = `/drillweb/learning-history/core-subjects-learning-amount`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (fiscalYear !== undefined) {
                localVarQueryParameter['fiscalYear'] = fiscalYear;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getMonthlyLearningAmount: (userId_1, subjects_1, fiscalYear_1, learningAmount_1, ...args_1) => __awaiter(this, [userId_1, subjects_1, fiscalYear_1, learningAmount_1, ...args_1], void 0, function* (userId, subjects, fiscalYear, learningAmount, options = {}) {
            assertParamExists('getMonthlyLearningAmount', 'userId', userId);
            assertParamExists('getMonthlyLearningAmount', 'subjects', subjects);
            assertParamExists('getMonthlyLearningAmount', 'fiscalYear', fiscalYear);
            assertParamExists('getMonthlyLearningAmount', 'learningAmount', learningAmount);
            const localVarPath = `/drillweb/learning-history/learning-amount`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (subjects) {
                localVarQueryParameter['subjects'] = subjects;
            }
            if (fiscalYear !== undefined) {
                localVarQueryParameter['fiscalYear'] = fiscalYear;
            }
            if (learningAmount !== undefined) {
                localVarQueryParameter['learningAmount'] = learningAmount;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getUnitCorrectAnswerRateDetail: (drillType_1, courseId_1, unitId_1, organizationId_1, correctAnswerRateType_1, ...args_1) => __awaiter(this, [drillType_1, courseId_1, unitId_1, organizationId_1, correctAnswerRateType_1, ...args_1], void 0, function* (drillType, courseId, unitId, organizationId, correctAnswerRateType, options = {}) {
            assertParamExists('getUnitCorrectAnswerRateDetail', 'drillType', drillType);
            assertParamExists('getUnitCorrectAnswerRateDetail', 'courseId', courseId);
            assertParamExists('getUnitCorrectAnswerRateDetail', 'unitId', unitId);
            assertParamExists('getUnitCorrectAnswerRateDetail', 'organizationId', organizationId);
            assertParamExists('getUnitCorrectAnswerRateDetail', 'correctAnswerRateType', correctAnswerRateType);
            const localVarPath = `/drillweb/learning-history/correct-answer-rate/courses/{courseId}/units/{unitId}/subunits`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"unitId"}}`, encodeURIComponent(String(unitId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (correctAnswerRateType !== undefined) {
                localVarQueryParameter['correctAnswerRateType'] = correctAnswerRateType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getUnitGradeCorrectAnswerRateDetail: (drillType_1, courseId_1, unitId_1, grade_1, correctAnswerRateType_1, ...args_1) => __awaiter(this, [drillType_1, courseId_1, unitId_1, grade_1, correctAnswerRateType_1, ...args_1], void 0, function* (drillType, courseId, unitId, grade, correctAnswerRateType, options = {}) {
            assertParamExists('getUnitGradeCorrectAnswerRateDetail', 'drillType', drillType);
            assertParamExists('getUnitGradeCorrectAnswerRateDetail', 'courseId', courseId);
            assertParamExists('getUnitGradeCorrectAnswerRateDetail', 'unitId', unitId);
            assertParamExists('getUnitGradeCorrectAnswerRateDetail', 'grade', grade);
            assertParamExists('getUnitGradeCorrectAnswerRateDetail', 'correctAnswerRateType', correctAnswerRateType);
            const localVarPath = `/drillweb/learning-history/grade-correct-answer-avg-rate/courses/{courseId}/units/{unitId}/subunits`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"unitId"}}`, encodeURIComponent(String(unitId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (grade !== undefined) {
                localVarQueryParameter['grade'] = grade;
            }
            if (correctAnswerRateType !== undefined) {
                localVarQueryParameter['correctAnswerRateType'] = correctAnswerRateType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const LearningHistoryControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = LearningHistoryControllerApiAxiosParamCreator(configuration);
    return {
        getAllUnitCorrectAnswerRates(drillType, courseId, organizationId, correctAnswerRateType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllUnitCorrectAnswerRates(drillType, courseId, organizationId, correctAnswerRateType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LearningHistoryControllerApi.getAllUnitCorrectAnswerRates']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getAllUnitsGradeCorrectAnswerRates(drillType, courseId, grade, correctAnswerRateType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllUnitsGradeCorrectAnswerRates(drillType, courseId, grade, correctAnswerRateType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LearningHistoryControllerApi.getAllUnitsGradeCorrectAnswerRates']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getMonthlyCoreSubjectsLearningAmount(userId, fiscalYear, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMonthlyCoreSubjectsLearningAmount(userId, fiscalYear, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LearningHistoryControllerApi.getMonthlyCoreSubjectsLearningAmount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getMonthlyLearningAmount(userId, subjects, fiscalYear, learningAmount, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMonthlyLearningAmount(userId, subjects, fiscalYear, learningAmount, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LearningHistoryControllerApi.getMonthlyLearningAmount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getUnitCorrectAnswerRateDetail(drillType, courseId, unitId, organizationId, correctAnswerRateType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUnitCorrectAnswerRateDetail(drillType, courseId, unitId, organizationId, correctAnswerRateType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LearningHistoryControllerApi.getUnitCorrectAnswerRateDetail']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getUnitGradeCorrectAnswerRateDetail(drillType, courseId, unitId, grade, correctAnswerRateType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUnitGradeCorrectAnswerRateDetail(drillType, courseId, unitId, grade, correctAnswerRateType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LearningHistoryControllerApi.getUnitGradeCorrectAnswerRateDetail']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const LearningHistoryControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LearningHistoryControllerApiFp(configuration);
    return {
        getAllUnitCorrectAnswerRates(drillType, courseId, organizationId, correctAnswerRateType, options) {
            return localVarFp.getAllUnitCorrectAnswerRates(drillType, courseId, organizationId, correctAnswerRateType, options).then((request) => request(axios, basePath));
        },
        getAllUnitsGradeCorrectAnswerRates(drillType, courseId, grade, correctAnswerRateType, options) {
            return localVarFp.getAllUnitsGradeCorrectAnswerRates(drillType, courseId, grade, correctAnswerRateType, options).then((request) => request(axios, basePath));
        },
        getMonthlyCoreSubjectsLearningAmount(userId, fiscalYear, options) {
            return localVarFp.getMonthlyCoreSubjectsLearningAmount(userId, fiscalYear, options).then((request) => request(axios, basePath));
        },
        getMonthlyLearningAmount(userId, subjects, fiscalYear, learningAmount, options) {
            return localVarFp.getMonthlyLearningAmount(userId, subjects, fiscalYear, learningAmount, options).then((request) => request(axios, basePath));
        },
        getUnitCorrectAnswerRateDetail(drillType, courseId, unitId, organizationId, correctAnswerRateType, options) {
            return localVarFp.getUnitCorrectAnswerRateDetail(drillType, courseId, unitId, organizationId, correctAnswerRateType, options).then((request) => request(axios, basePath));
        },
        getUnitGradeCorrectAnswerRateDetail(drillType, courseId, unitId, grade, correctAnswerRateType, options) {
            return localVarFp.getUnitGradeCorrectAnswerRateDetail(drillType, courseId, unitId, grade, correctAnswerRateType, options).then((request) => request(axios, basePath));
        },
    };
};
export class LearningHistoryControllerApi extends BaseAPI {
    getAllUnitCorrectAnswerRates(drillType, courseId, organizationId, correctAnswerRateType, options) {
        return LearningHistoryControllerApiFp(this.configuration).getAllUnitCorrectAnswerRates(drillType, courseId, organizationId, correctAnswerRateType, options).then((request) => request(this.axios, this.basePath));
    }
    getAllUnitsGradeCorrectAnswerRates(drillType, courseId, grade, correctAnswerRateType, options) {
        return LearningHistoryControllerApiFp(this.configuration).getAllUnitsGradeCorrectAnswerRates(drillType, courseId, grade, correctAnswerRateType, options).then((request) => request(this.axios, this.basePath));
    }
    getMonthlyCoreSubjectsLearningAmount(userId, fiscalYear, options) {
        return LearningHistoryControllerApiFp(this.configuration).getMonthlyCoreSubjectsLearningAmount(userId, fiscalYear, options).then((request) => request(this.axios, this.basePath));
    }
    getMonthlyLearningAmount(userId, subjects, fiscalYear, learningAmount, options) {
        return LearningHistoryControllerApiFp(this.configuration).getMonthlyLearningAmount(userId, subjects, fiscalYear, learningAmount, options).then((request) => request(this.axios, this.basePath));
    }
    getUnitCorrectAnswerRateDetail(drillType, courseId, unitId, organizationId, correctAnswerRateType, options) {
        return LearningHistoryControllerApiFp(this.configuration).getUnitCorrectAnswerRateDetail(drillType, courseId, unitId, organizationId, correctAnswerRateType, options).then((request) => request(this.axios, this.basePath));
    }
    getUnitGradeCorrectAnswerRateDetail(drillType, courseId, unitId, grade, correctAnswerRateType, options) {
        return LearningHistoryControllerApiFp(this.configuration).getUnitGradeCorrectAnswerRateDetail(drillType, courseId, unitId, grade, correctAnswerRateType, options).then((request) => request(this.axios, this.basePath));
    }
}
export const GetMonthlyLearningAmountSubjectsEnum = {
    Kokugo: 'KOKUGO',
    Sansu: 'SANSU',
    Rika: 'RIKA',
    Shakai: 'SHAKAI',
    Eigo: 'EIGO',
    ChugakuKokugo: 'CHUGAKU_KOKUGO',
    ChugakuSugaku: 'CHUGAKU_SUGAKU',
    ChugakuEndrill: 'CHUGAKU_ENDRILL',
    ChugakuRika: 'CHUGAKU_RIKA',
    ChugakuShakai: 'CHUGAKU_SHAKAI',
    ChugakuJitsugi: 'CHUGAKU_JITSUGI',
    Nihongo: 'NIHONGO',
    AllSubject: 'ALL_SUBJECT'
};
export const LevelupDrillControllerApiAxiosParamCreator = function (configuration) {
    return {
        getAwards: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/drillweb/levelup/award`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getLevelupDrillEffortStatus: (userIds_1, courseId_1, unitIds_1, drillType_1, ...args_1) => __awaiter(this, [userIds_1, courseId_1, unitIds_1, drillType_1, ...args_1], void 0, function* (userIds, courseId, unitIds, drillType, options = {}) {
            assertParamExists('getLevelupDrillEffortStatus', 'userIds', userIds);
            assertParamExists('getLevelupDrillEffortStatus', 'courseId', courseId);
            assertParamExists('getLevelupDrillEffortStatus', 'unitIds', unitIds);
            assertParamExists('getLevelupDrillEffortStatus', 'drillType', drillType);
            const localVarPath = `/drillweb/levelup/level`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }
            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }
            if (unitIds) {
                localVarQueryParameter['unitIds'] = unitIds;
            }
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getLevelupDrillMyEffortStatus: (courseId_1, unitIds_1, drillType_1, ...args_1) => __awaiter(this, [courseId_1, unitIds_1, drillType_1, ...args_1], void 0, function* (courseId, unitIds, drillType, options = {}) {
            assertParamExists('getLevelupDrillMyEffortStatus', 'courseId', courseId);
            assertParamExists('getLevelupDrillMyEffortStatus', 'unitIds', unitIds);
            assertParamExists('getLevelupDrillMyEffortStatus', 'drillType', drillType);
            const localVarPath = `/drillweb/levelup/level/self`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }
            if (unitIds) {
                localVarQueryParameter['unitIds'] = unitIds;
            }
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getMyQuestions: (drillType_1, unitId_1, questionCount_1, ...args_1) => __awaiter(this, [drillType_1, unitId_1, questionCount_1, ...args_1], void 0, function* (drillType, unitId, questionCount, options = {}) {
            assertParamExists('getMyQuestions', 'drillType', drillType);
            assertParamExists('getMyQuestions', 'unitId', unitId);
            assertParamExists('getMyQuestions', 'questionCount', questionCount);
            const localVarPath = `/drillweb/levelup/questions/self`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }
            if (questionCount !== undefined) {
                localVarQueryParameter['questionCount'] = questionCount;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const LevelupDrillControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = LevelupDrillControllerApiAxiosParamCreator(configuration);
    return {
        getAwards(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAwards(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillControllerApi.getAwards']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getLevelupDrillEffortStatus(userIds, courseId, unitIds, drillType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLevelupDrillEffortStatus(userIds, courseId, unitIds, drillType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillControllerApi.getLevelupDrillEffortStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getLevelupDrillMyEffortStatus(courseId, unitIds, drillType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLevelupDrillMyEffortStatus(courseId, unitIds, drillType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillControllerApi.getLevelupDrillMyEffortStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getMyQuestions(drillType, unitId, questionCount, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyQuestions(drillType, unitId, questionCount, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillControllerApi.getMyQuestions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const LevelupDrillControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LevelupDrillControllerApiFp(configuration);
    return {
        getAwards(options) {
            return localVarFp.getAwards(options).then((request) => request(axios, basePath));
        },
        getLevelupDrillEffortStatus(userIds, courseId, unitIds, drillType, options) {
            return localVarFp.getLevelupDrillEffortStatus(userIds, courseId, unitIds, drillType, options).then((request) => request(axios, basePath));
        },
        getLevelupDrillMyEffortStatus(courseId, unitIds, drillType, options) {
            return localVarFp.getLevelupDrillMyEffortStatus(courseId, unitIds, drillType, options).then((request) => request(axios, basePath));
        },
        getMyQuestions(drillType, unitId, questionCount, options) {
            return localVarFp.getMyQuestions(drillType, unitId, questionCount, options).then((request) => request(axios, basePath));
        },
    };
};
export class LevelupDrillControllerApi extends BaseAPI {
    getAwards(options) {
        return LevelupDrillControllerApiFp(this.configuration).getAwards(options).then((request) => request(this.axios, this.basePath));
    }
    getLevelupDrillEffortStatus(userIds, courseId, unitIds, drillType, options) {
        return LevelupDrillControllerApiFp(this.configuration).getLevelupDrillEffortStatus(userIds, courseId, unitIds, drillType, options).then((request) => request(this.axios, this.basePath));
    }
    getLevelupDrillMyEffortStatus(courseId, unitIds, drillType, options) {
        return LevelupDrillControllerApiFp(this.configuration).getLevelupDrillMyEffortStatus(courseId, unitIds, drillType, options).then((request) => request(this.axios, this.basePath));
    }
    getMyQuestions(drillType, unitId, questionCount, options) {
        return LevelupDrillControllerApiFp(this.configuration).getMyQuestions(drillType, unitId, questionCount, options).then((request) => request(this.axios, this.basePath));
    }
}
export const LevelupDrillHistoryControllerApiAxiosParamCreator = function (configuration) {
    return {
        addLevelupDrillHistory: (addLevelupDrillHistoryRequest_1, ...args_1) => __awaiter(this, [addLevelupDrillHistoryRequest_1, ...args_1], void 0, function* (addLevelupDrillHistoryRequest, options = {}) {
            assertParamExists('addLevelupDrillHistory', 'addLevelupDrillHistoryRequest', addLevelupDrillHistoryRequest);
            const localVarPath = `/drillweb/levelupDrillHistory`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addLevelupDrillHistoryRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getLevelupDrillHistories: (ids_1, ...args_1) => __awaiter(this, [ids_1, ...args_1], void 0, function* (ids, options = {}) {
            assertParamExists('getLevelupDrillHistories', 'ids', ids);
            const localVarPath = `/drillweb/levelupDrillHistory/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updatePhase1: (levelupDrillHistoryId_1, updateLevelupDrillHistoryPhaseRequest_1, ...args_1) => __awaiter(this, [levelupDrillHistoryId_1, updateLevelupDrillHistoryPhaseRequest_1, ...args_1], void 0, function* (levelupDrillHistoryId, updateLevelupDrillHistoryPhaseRequest, options = {}) {
            assertParamExists('updatePhase1', 'levelupDrillHistoryId', levelupDrillHistoryId);
            assertParamExists('updatePhase1', 'updateLevelupDrillHistoryPhaseRequest', updateLevelupDrillHistoryPhaseRequest);
            const localVarPath = `/drillweb/levelupDrillHistory/{levelupDrillHistoryId}`
                .replace(`{${"levelupDrillHistoryId"}}`, encodeURIComponent(String(levelupDrillHistoryId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateLevelupDrillHistoryPhaseRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const LevelupDrillHistoryControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = LevelupDrillHistoryControllerApiAxiosParamCreator(configuration);
    return {
        addLevelupDrillHistory(addLevelupDrillHistoryRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addLevelupDrillHistory(addLevelupDrillHistoryRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillHistoryControllerApi.addLevelupDrillHistory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getLevelupDrillHistories(ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLevelupDrillHistories(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillHistoryControllerApi.getLevelupDrillHistories']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        updatePhase1(levelupDrillHistoryId, updateLevelupDrillHistoryPhaseRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePhase1(levelupDrillHistoryId, updateLevelupDrillHistoryPhaseRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillHistoryControllerApi.updatePhase1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const LevelupDrillHistoryControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LevelupDrillHistoryControllerApiFp(configuration);
    return {
        addLevelupDrillHistory(addLevelupDrillHistoryRequest, options) {
            return localVarFp.addLevelupDrillHistory(addLevelupDrillHistoryRequest, options).then((request) => request(axios, basePath));
        },
        getLevelupDrillHistories(ids, options) {
            return localVarFp.getLevelupDrillHistories(ids, options).then((request) => request(axios, basePath));
        },
        updatePhase1(levelupDrillHistoryId, updateLevelupDrillHistoryPhaseRequest, options) {
            return localVarFp.updatePhase1(levelupDrillHistoryId, updateLevelupDrillHistoryPhaseRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class LevelupDrillHistoryControllerApi extends BaseAPI {
    addLevelupDrillHistory(addLevelupDrillHistoryRequest, options) {
        return LevelupDrillHistoryControllerApiFp(this.configuration).addLevelupDrillHistory(addLevelupDrillHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    getLevelupDrillHistories(ids, options) {
        return LevelupDrillHistoryControllerApiFp(this.configuration).getLevelupDrillHistories(ids, options).then((request) => request(this.axios, this.basePath));
    }
    updatePhase1(levelupDrillHistoryId, updateLevelupDrillHistoryPhaseRequest, options) {
        return LevelupDrillHistoryControllerApiFp(this.configuration).updatePhase1(levelupDrillHistoryId, updateLevelupDrillHistoryPhaseRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const LevelupDrillQuestionHistoryDetailControllerApiAxiosParamCreator = function (configuration) {
    return {
        addLevelupDrillQuestionHistoryDetail: (levelupDrillHistoryId_1, addLevelupDrillQuestionHistoryDetailsRequest_1, ...args_1) => __awaiter(this, [levelupDrillHistoryId_1, addLevelupDrillQuestionHistoryDetailsRequest_1, ...args_1], void 0, function* (levelupDrillHistoryId, addLevelupDrillQuestionHistoryDetailsRequest, options = {}) {
            assertParamExists('addLevelupDrillQuestionHistoryDetail', 'levelupDrillHistoryId', levelupDrillHistoryId);
            assertParamExists('addLevelupDrillQuestionHistoryDetail', 'addLevelupDrillQuestionHistoryDetailsRequest', addLevelupDrillQuestionHistoryDetailsRequest);
            const localVarPath = `/drillweb/levelupDrillHistory/{levelupDrillHistoryId}/questionHistory`
                .replace(`{${"levelupDrillHistoryId"}}`, encodeURIComponent(String(levelupDrillHistoryId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addLevelupDrillQuestionHistoryDetailsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        addLevelupDrillQuestionHistoryDetail1: (levelupDrillHistoryId_1, updateLevelupDrillQuestionHistoryDetailsRequest_1, ...args_1) => __awaiter(this, [levelupDrillHistoryId_1, updateLevelupDrillQuestionHistoryDetailsRequest_1, ...args_1], void 0, function* (levelupDrillHistoryId, updateLevelupDrillQuestionHistoryDetailsRequest, options = {}) {
            assertParamExists('addLevelupDrillQuestionHistoryDetail1', 'levelupDrillHistoryId', levelupDrillHistoryId);
            assertParamExists('addLevelupDrillQuestionHistoryDetail1', 'updateLevelupDrillQuestionHistoryDetailsRequest', updateLevelupDrillQuestionHistoryDetailsRequest);
            const localVarPath = `/drillweb/levelupDrillHistory/{levelupDrillHistoryId}/questionHistory`
                .replace(`{${"levelupDrillHistoryId"}}`, encodeURIComponent(String(levelupDrillHistoryId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateLevelupDrillQuestionHistoryDetailsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const LevelupDrillQuestionHistoryDetailControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = LevelupDrillQuestionHistoryDetailControllerApiAxiosParamCreator(configuration);
    return {
        addLevelupDrillQuestionHistoryDetail(levelupDrillHistoryId, addLevelupDrillQuestionHistoryDetailsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addLevelupDrillQuestionHistoryDetail(levelupDrillHistoryId, addLevelupDrillQuestionHistoryDetailsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillQuestionHistoryDetailControllerApi.addLevelupDrillQuestionHistoryDetail']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        addLevelupDrillQuestionHistoryDetail1(levelupDrillHistoryId, updateLevelupDrillQuestionHistoryDetailsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addLevelupDrillQuestionHistoryDetail1(levelupDrillHistoryId, updateLevelupDrillQuestionHistoryDetailsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillQuestionHistoryDetailControllerApi.addLevelupDrillQuestionHistoryDetail1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const LevelupDrillQuestionHistoryDetailControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LevelupDrillQuestionHistoryDetailControllerApiFp(configuration);
    return {
        addLevelupDrillQuestionHistoryDetail(levelupDrillHistoryId, addLevelupDrillQuestionHistoryDetailsRequest, options) {
            return localVarFp.addLevelupDrillQuestionHistoryDetail(levelupDrillHistoryId, addLevelupDrillQuestionHistoryDetailsRequest, options).then((request) => request(axios, basePath));
        },
        addLevelupDrillQuestionHistoryDetail1(levelupDrillHistoryId, updateLevelupDrillQuestionHistoryDetailsRequest, options) {
            return localVarFp.addLevelupDrillQuestionHistoryDetail1(levelupDrillHistoryId, updateLevelupDrillQuestionHistoryDetailsRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class LevelupDrillQuestionHistoryDetailControllerApi extends BaseAPI {
    addLevelupDrillQuestionHistoryDetail(levelupDrillHistoryId, addLevelupDrillQuestionHistoryDetailsRequest, options) {
        return LevelupDrillQuestionHistoryDetailControllerApiFp(this.configuration).addLevelupDrillQuestionHistoryDetail(levelupDrillHistoryId, addLevelupDrillQuestionHistoryDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    addLevelupDrillQuestionHistoryDetail1(levelupDrillHistoryId, updateLevelupDrillQuestionHistoryDetailsRequest, options) {
        return LevelupDrillQuestionHistoryDetailControllerApiFp(this.configuration).addLevelupDrillQuestionHistoryDetail1(levelupDrillHistoryId, updateLevelupDrillQuestionHistoryDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const LevelupDrillRecommendControllerApiAxiosParamCreator = function (configuration) {
    return {
        addTeacherRecommend: (addTeacherRecommendRequest_1, ...args_1) => __awaiter(this, [addTeacherRecommendRequest_1, ...args_1], void 0, function* (addTeacherRecommendRequest, options = {}) {
            assertParamExists('addTeacherRecommend', 'addTeacherRecommendRequest', addTeacherRecommendRequest);
            const localVarPath = `/drillweb/levelup/recommend/teacher`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addTeacherRecommendRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        deleteTeacherRecommend: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('deleteTeacherRecommend', 'id', id);
            const localVarPath = `/drillweb/levelup/recommend/teacher/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getRecommends: (userIds_1, ...args_1) => __awaiter(this, [userIds_1, ...args_1], void 0, function* (userIds, options = {}) {
            assertParamExists('getRecommends', 'userIds', userIds);
            const localVarPath = `/drillweb/levelup/recommend`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getRecommendsStreaming: (userIds_1, ...args_1) => __awaiter(this, [userIds_1, ...args_1], void 0, function* (userIds, options = {}) {
            assertParamExists('getRecommendsStreaming', 'userIds', userIds);
            const localVarPath = `/drillweb/levelup/recommend/streaming`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getSelf: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/drillweb/levelup/recommend/self`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getTeacherRecommendHistory: (drillType_1, userIds_1, ...args_1) => __awaiter(this, [drillType_1, userIds_1, ...args_1], void 0, function* (drillType, userIds, options = {}) {
            assertParamExists('getTeacherRecommendHistory', 'drillType', drillType);
            assertParamExists('getTeacherRecommendHistory', 'userIds', userIds);
            const localVarPath = `/drillweb/levelup/recommend/teacher/history`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const LevelupDrillRecommendControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = LevelupDrillRecommendControllerApiAxiosParamCreator(configuration);
    return {
        addTeacherRecommend(addTeacherRecommendRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addTeacherRecommend(addTeacherRecommendRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillRecommendControllerApi.addTeacherRecommend']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        deleteTeacherRecommend(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTeacherRecommend(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillRecommendControllerApi.deleteTeacherRecommend']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getRecommends(userIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecommends(userIds, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillRecommendControllerApi.getRecommends']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getRecommendsStreaming(userIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecommendsStreaming(userIds, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillRecommendControllerApi.getRecommendsStreaming']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getSelf(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSelf(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillRecommendControllerApi.getSelf']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getTeacherRecommendHistory(drillType, userIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTeacherRecommendHistory(drillType, userIds, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LevelupDrillRecommendControllerApi.getTeacherRecommendHistory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const LevelupDrillRecommendControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LevelupDrillRecommendControllerApiFp(configuration);
    return {
        addTeacherRecommend(addTeacherRecommendRequest, options) {
            return localVarFp.addTeacherRecommend(addTeacherRecommendRequest, options).then((request) => request(axios, basePath));
        },
        deleteTeacherRecommend(id, options) {
            return localVarFp.deleteTeacherRecommend(id, options).then((request) => request(axios, basePath));
        },
        getRecommends(userIds, options) {
            return localVarFp.getRecommends(userIds, options).then((request) => request(axios, basePath));
        },
        getRecommendsStreaming(userIds, options) {
            return localVarFp.getRecommendsStreaming(userIds, options).then((request) => request(axios, basePath));
        },
        getSelf(options) {
            return localVarFp.getSelf(options).then((request) => request(axios, basePath));
        },
        getTeacherRecommendHistory(drillType, userIds, options) {
            return localVarFp.getTeacherRecommendHistory(drillType, userIds, options).then((request) => request(axios, basePath));
        },
    };
};
export class LevelupDrillRecommendControllerApi extends BaseAPI {
    addTeacherRecommend(addTeacherRecommendRequest, options) {
        return LevelupDrillRecommendControllerApiFp(this.configuration).addTeacherRecommend(addTeacherRecommendRequest, options).then((request) => request(this.axios, this.basePath));
    }
    deleteTeacherRecommend(id, options) {
        return LevelupDrillRecommendControllerApiFp(this.configuration).deleteTeacherRecommend(id, options).then((request) => request(this.axios, this.basePath));
    }
    getRecommends(userIds, options) {
        return LevelupDrillRecommendControllerApiFp(this.configuration).getRecommends(userIds, options).then((request) => request(this.axios, this.basePath));
    }
    getRecommendsStreaming(userIds, options) {
        return LevelupDrillRecommendControllerApiFp(this.configuration).getRecommendsStreaming(userIds, options).then((request) => request(this.axios, this.basePath));
    }
    getSelf(options) {
        return LevelupDrillRecommendControllerApiFp(this.configuration).getSelf(options).then((request) => request(this.axios, this.basePath));
    }
    getTeacherRecommendHistory(drillType, userIds, options) {
        return LevelupDrillRecommendControllerApiFp(this.configuration).getTeacherRecommendHistory(drillType, userIds, options).then((request) => request(this.axios, this.basePath));
    }
}
export const QuestionControllerApiAxiosParamCreator = function (configuration) {
    return {
        getAutoSelectedQuestionList: (drillType_1, unitId_1, subunitIds_1, kinds_1, estimatedWorkingTime_1, ...args_1) => __awaiter(this, [drillType_1, unitId_1, subunitIds_1, kinds_1, estimatedWorkingTime_1, ...args_1], void 0, function* (drillType, unitId, subunitIds, kinds, estimatedWorkingTime, options = {}) {
            assertParamExists('getAutoSelectedQuestionList', 'drillType', drillType);
            assertParamExists('getAutoSelectedQuestionList', 'unitId', unitId);
            const localVarPath = `/drillweb/work/autoSelectQuestion`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }
            if (subunitIds) {
                localVarQueryParameter['subunitIds'] = subunitIds;
            }
            if (kinds) {
                localVarQueryParameter['kinds'] = kinds;
            }
            if (estimatedWorkingTime !== undefined) {
                localVarQueryParameter['estimatedWorkingTime'] = estimatedWorkingTime;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const QuestionControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = QuestionControllerApiAxiosParamCreator(configuration);
    return {
        getAutoSelectedQuestionList(drillType, unitId, subunitIds, kinds, estimatedWorkingTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAutoSelectedQuestionList(drillType, unitId, subunitIds, kinds, estimatedWorkingTime, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['QuestionControllerApi.getAutoSelectedQuestionList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const QuestionControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = QuestionControllerApiFp(configuration);
    return {
        getAutoSelectedQuestionList(drillType, unitId, subunitIds, kinds, estimatedWorkingTime, options) {
            return localVarFp.getAutoSelectedQuestionList(drillType, unitId, subunitIds, kinds, estimatedWorkingTime, options).then((request) => request(axios, basePath));
        },
    };
};
export class QuestionControllerApi extends BaseAPI {
    getAutoSelectedQuestionList(drillType, unitId, subunitIds, kinds, estimatedWorkingTime, options) {
        return QuestionControllerApiFp(this.configuration).getAutoSelectedQuestionList(drillType, unitId, subunitIds, kinds, estimatedWorkingTime, options).then((request) => request(this.axios, this.basePath));
    }
}
export const WorkAnswerHistoryControllerApiAxiosParamCreator = function (configuration) {
    return {
        getAnswerByOriginWorkId: (originWorkId_1, userId_1, onlyFirst_1, ...args_1) => __awaiter(this, [originWorkId_1, userId_1, onlyFirst_1, ...args_1], void 0, function* (originWorkId, userId, onlyFirst, options = {}) {
            assertParamExists('getAnswerByOriginWorkId', 'originWorkId', originWorkId);
            assertParamExists('getAnswerByOriginWorkId', 'userId', userId);
            assertParamExists('getAnswerByOriginWorkId', 'onlyFirst', onlyFirst);
            const localVarPath = `/drillweb/workHistory/answer`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (originWorkId !== undefined) {
                localVarQueryParameter['originWorkId'] = originWorkId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (onlyFirst !== undefined) {
                localVarQueryParameter['onlyFirst'] = onlyFirst;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const WorkAnswerHistoryControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkAnswerHistoryControllerApiAxiosParamCreator(configuration);
    return {
        getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkAnswerHistoryControllerApi.getAnswerByOriginWorkId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const WorkAnswerHistoryControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkAnswerHistoryControllerApiFp(configuration);
    return {
        getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options) {
            return localVarFp.getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options).then((request) => request(axios, basePath));
        },
    };
};
export class WorkAnswerHistoryControllerApi extends BaseAPI {
    getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options) {
        return WorkAnswerHistoryControllerApiFp(this.configuration).getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options).then((request) => request(this.axios, this.basePath));
    }
}
export const WorkControllerApiAxiosParamCreator = function (configuration) {
    return {
        addExamPreparationWork: (addExamPreparationWorkRequest_1, ...args_1) => __awaiter(this, [addExamPreparationWorkRequest_1, ...args_1], void 0, function* (addExamPreparationWorkRequest, options = {}) {
            assertParamExists('addExamPreparationWork', 'addExamPreparationWorkRequest', addExamPreparationWorkRequest);
            const localVarPath = `/drillweb/works/examPreparationWork`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addExamPreparationWorkRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        addWork: (addWorkRequest_1, ...args_1) => __awaiter(this, [addWorkRequest_1, ...args_1], void 0, function* (addWorkRequest, options = {}) {
            assertParamExists('addWork', 'addWorkRequest', addWorkRequest);
            const localVarPath = `/drillweb/works`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addWorkRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        cloneWork: (cloneWorkRequest_1, ...args_1) => __awaiter(this, [cloneWorkRequest_1, ...args_1], void 0, function* (cloneWorkRequest, options = {}) {
            assertParamExists('cloneWork', 'cloneWorkRequest', cloneWorkRequest);
            const localVarPath = `/drillweb/works/clone`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cloneWorkRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        deleteWork: (workId_1, ...args_1) => __awaiter(this, [workId_1, ...args_1], void 0, function* (workId, options = {}) {
            assertParamExists('deleteWork', 'workId', workId);
            const localVarPath = `/drillweb/works/{workId}`
                .replace(`{${"workId"}}`, encodeURIComponent(String(workId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getWorkById: (workId_1, checkWork_1, ...args_1) => __awaiter(this, [workId_1, checkWork_1, ...args_1], void 0, function* (workId, checkWork, options = {}) {
            assertParamExists('getWorkById', 'workId', workId);
            const localVarPath = `/drillweb/works/{workId}`
                .replace(`{${"workId"}}`, encodeURIComponent(String(workId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (checkWork !== undefined) {
                localVarQueryParameter['checkWork'] = checkWork;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getWorkList: (fileSort_1, order_1, size_1, page_1, workType_1, targetUserId_1, name_1, afterCreatedDateTime_1, untilCreatedDateTime_1, drillType_1, ...args_1) => __awaiter(this, [fileSort_1, order_1, size_1, page_1, workType_1, targetUserId_1, name_1, afterCreatedDateTime_1, untilCreatedDateTime_1, drillType_1, ...args_1], void 0, function* (fileSort, order, size, page, workType, targetUserId, name, afterCreatedDateTime, untilCreatedDateTime, drillType, options = {}) {
            assertParamExists('getWorkList', 'fileSort', fileSort);
            assertParamExists('getWorkList', 'order', order);
            assertParamExists('getWorkList', 'size', size);
            assertParamExists('getWorkList', 'page', page);
            const localVarPath = `/drillweb/works`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (workType !== undefined) {
                localVarQueryParameter['workType'] = workType;
            }
            if (targetUserId !== undefined) {
                localVarQueryParameter['targetUserId'] = targetUserId;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (afterCreatedDateTime !== undefined) {
                localVarQueryParameter['afterCreatedDateTime'] = afterCreatedDateTime;
            }
            if (untilCreatedDateTime !== undefined) {
                localVarQueryParameter['untilCreatedDateTime'] = untilCreatedDateTime;
            }
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (fileSort !== undefined) {
                localVarQueryParameter['fileSort'] = fileSort;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateWork: (workId_1, updateWorkRequest_1, ...args_1) => __awaiter(this, [workId_1, updateWorkRequest_1, ...args_1], void 0, function* (workId, updateWorkRequest, options = {}) {
            assertParamExists('updateWork', 'workId', workId);
            assertParamExists('updateWork', 'updateWorkRequest', updateWorkRequest);
            const localVarPath = `/drillweb/works/{workId}`
                .replace(`{${"workId"}}`, encodeURIComponent(String(workId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const WorkControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkControllerApiAxiosParamCreator(configuration);
    return {
        addExamPreparationWork(addExamPreparationWorkRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addExamPreparationWork(addExamPreparationWorkRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkControllerApi.addExamPreparationWork']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        addWork(addWorkRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addWork(addWorkRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkControllerApi.addWork']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        cloneWork(cloneWorkRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cloneWork(cloneWorkRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkControllerApi.cloneWork']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        deleteWork(workId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteWork(workId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkControllerApi.deleteWork']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getWorkById(workId, checkWork, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkById(workId, checkWork, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkControllerApi.getWorkById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getWorkList(fileSort, order, size, page, workType, targetUserId, name, afterCreatedDateTime, untilCreatedDateTime, drillType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkList(fileSort, order, size, page, workType, targetUserId, name, afterCreatedDateTime, untilCreatedDateTime, drillType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkControllerApi.getWorkList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        updateWork(workId, updateWorkRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateWork(workId, updateWorkRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkControllerApi.updateWork']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const WorkControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkControllerApiFp(configuration);
    return {
        addExamPreparationWork(addExamPreparationWorkRequest, options) {
            return localVarFp.addExamPreparationWork(addExamPreparationWorkRequest, options).then((request) => request(axios, basePath));
        },
        addWork(addWorkRequest, options) {
            return localVarFp.addWork(addWorkRequest, options).then((request) => request(axios, basePath));
        },
        cloneWork(cloneWorkRequest, options) {
            return localVarFp.cloneWork(cloneWorkRequest, options).then((request) => request(axios, basePath));
        },
        deleteWork(workId, options) {
            return localVarFp.deleteWork(workId, options).then((request) => request(axios, basePath));
        },
        getWorkById(workId, checkWork, options) {
            return localVarFp.getWorkById(workId, checkWork, options).then((request) => request(axios, basePath));
        },
        getWorkList(fileSort, order, size, page, workType, targetUserId, name, afterCreatedDateTime, untilCreatedDateTime, drillType, options) {
            return localVarFp.getWorkList(fileSort, order, size, page, workType, targetUserId, name, afterCreatedDateTime, untilCreatedDateTime, drillType, options).then((request) => request(axios, basePath));
        },
        updateWork(workId, updateWorkRequest, options) {
            return localVarFp.updateWork(workId, updateWorkRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class WorkControllerApi extends BaseAPI {
    addExamPreparationWork(addExamPreparationWorkRequest, options) {
        return WorkControllerApiFp(this.configuration).addExamPreparationWork(addExamPreparationWorkRequest, options).then((request) => request(this.axios, this.basePath));
    }
    addWork(addWorkRequest, options) {
        return WorkControllerApiFp(this.configuration).addWork(addWorkRequest, options).then((request) => request(this.axios, this.basePath));
    }
    cloneWork(cloneWorkRequest, options) {
        return WorkControllerApiFp(this.configuration).cloneWork(cloneWorkRequest, options).then((request) => request(this.axios, this.basePath));
    }
    deleteWork(workId, options) {
        return WorkControllerApiFp(this.configuration).deleteWork(workId, options).then((request) => request(this.axios, this.basePath));
    }
    getWorkById(workId, checkWork, options) {
        return WorkControllerApiFp(this.configuration).getWorkById(workId, checkWork, options).then((request) => request(this.axios, this.basePath));
    }
    getWorkList(fileSort, order, size, page, workType, targetUserId, name, afterCreatedDateTime, untilCreatedDateTime, drillType, options) {
        return WorkControllerApiFp(this.configuration).getWorkList(fileSort, order, size, page, workType, targetUserId, name, afterCreatedDateTime, untilCreatedDateTime, drillType, options).then((request) => request(this.axios, this.basePath));
    }
    updateWork(workId, updateWorkRequest, options) {
        return WorkControllerApiFp(this.configuration).updateWork(workId, updateWorkRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const WorkHistoryControllerApiAxiosParamCreator = function (configuration) {
    return {
        addWorkHistory: (addWorkHistoryRequest_1, ...args_1) => __awaiter(this, [addWorkHistoryRequest_1, ...args_1], void 0, function* (addWorkHistoryRequest, options = {}) {
            assertParamExists('addWorkHistory', 'addWorkHistoryRequest', addWorkHistoryRequest);
            const localVarPath = `/drillweb/workHistory`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addWorkHistoryRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getAnswerByOriginWorkId: (originWorkId_1, userId_1, onlyFirst_1, ...args_1) => __awaiter(this, [originWorkId_1, userId_1, onlyFirst_1, ...args_1], void 0, function* (originWorkId, userId, onlyFirst, options = {}) {
            assertParamExists('getAnswerByOriginWorkId', 'originWorkId', originWorkId);
            assertParamExists('getAnswerByOriginWorkId', 'userId', userId);
            assertParamExists('getAnswerByOriginWorkId', 'onlyFirst', onlyFirst);
            const localVarPath = `/drillweb/workHistory/answer`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (originWorkId !== undefined) {
                localVarQueryParameter['originWorkId'] = originWorkId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (onlyFirst !== undefined) {
                localVarQueryParameter['onlyFirst'] = onlyFirst;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getWorkHistories: (ids_1, ...args_1) => __awaiter(this, [ids_1, ...args_1], void 0, function* (ids, options = {}) {
            assertParamExists('getWorkHistories', 'ids', ids);
            const localVarPath = `/drillweb/workHistory/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        resume: (workId_1, ...args_1) => __awaiter(this, [workId_1, ...args_1], void 0, function* (workId, options = {}) {
            assertParamExists('resume', 'workId', workId);
            const localVarPath = `/drillweb/workHistory/resume`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (workId !== undefined) {
                localVarQueryParameter['workId'] = workId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updatePhase: (workHistoryId_1, updateWorkHistoryPhaseRequest_1, ...args_1) => __awaiter(this, [workHistoryId_1, updateWorkHistoryPhaseRequest_1, ...args_1], void 0, function* (workHistoryId, updateWorkHistoryPhaseRequest, options = {}) {
            assertParamExists('updatePhase', 'workHistoryId', workHistoryId);
            assertParamExists('updatePhase', 'updateWorkHistoryPhaseRequest', updateWorkHistoryPhaseRequest);
            const localVarPath = `/drillweb/workHistory/{workHistoryId}`
                .replace(`{${"workHistoryId"}}`, encodeURIComponent(String(workHistoryId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkHistoryPhaseRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const WorkHistoryControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkHistoryControllerApiAxiosParamCreator(configuration);
    return {
        addWorkHistory(addWorkHistoryRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addWorkHistory(addWorkHistoryRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkHistoryControllerApi.addWorkHistory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkHistoryControllerApi.getAnswerByOriginWorkId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getWorkHistories(ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkHistories(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkHistoryControllerApi.getWorkHistories']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        resume(workId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resume(workId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkHistoryControllerApi.resume']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        updatePhase(workHistoryId, updateWorkHistoryPhaseRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePhase(workHistoryId, updateWorkHistoryPhaseRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkHistoryControllerApi.updatePhase']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const WorkHistoryControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkHistoryControllerApiFp(configuration);
    return {
        addWorkHistory(addWorkHistoryRequest, options) {
            return localVarFp.addWorkHistory(addWorkHistoryRequest, options).then((request) => request(axios, basePath));
        },
        getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options) {
            return localVarFp.getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options).then((request) => request(axios, basePath));
        },
        getWorkHistories(ids, options) {
            return localVarFp.getWorkHistories(ids, options).then((request) => request(axios, basePath));
        },
        resume(workId, options) {
            return localVarFp.resume(workId, options).then((request) => request(axios, basePath));
        },
        updatePhase(workHistoryId, updateWorkHistoryPhaseRequest, options) {
            return localVarFp.updatePhase(workHistoryId, updateWorkHistoryPhaseRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class WorkHistoryControllerApi extends BaseAPI {
    addWorkHistory(addWorkHistoryRequest, options) {
        return WorkHistoryControllerApiFp(this.configuration).addWorkHistory(addWorkHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options) {
        return WorkHistoryControllerApiFp(this.configuration).getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options).then((request) => request(this.axios, this.basePath));
    }
    getWorkHistories(ids, options) {
        return WorkHistoryControllerApiFp(this.configuration).getWorkHistories(ids, options).then((request) => request(this.axios, this.basePath));
    }
    resume(workId, options) {
        return WorkHistoryControllerApiFp(this.configuration).resume(workId, options).then((request) => request(this.axios, this.basePath));
    }
    updatePhase(workHistoryId, updateWorkHistoryPhaseRequest, options) {
        return WorkHistoryControllerApiFp(this.configuration).updatePhase(workHistoryId, updateWorkHistoryPhaseRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const WorkQuestionHistoryDetailControllerApiAxiosParamCreator = function (configuration) {
    return {
        addWorkQuestionHistoryDetail: (workHistoryId_1, addWorkQuestionHistoryDetailsRequest_1, ...args_1) => __awaiter(this, [workHistoryId_1, addWorkQuestionHistoryDetailsRequest_1, ...args_1], void 0, function* (workHistoryId, addWorkQuestionHistoryDetailsRequest, options = {}) {
            assertParamExists('addWorkQuestionHistoryDetail', 'workHistoryId', workHistoryId);
            assertParamExists('addWorkQuestionHistoryDetail', 'addWorkQuestionHistoryDetailsRequest', addWorkQuestionHistoryDetailsRequest);
            const localVarPath = `/drillweb/workHistory/{workHistoryId}/questionHistory`
                .replace(`{${"workHistoryId"}}`, encodeURIComponent(String(workHistoryId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addWorkQuestionHistoryDetailsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        addWorkQuestionHistoryDetail1: (workHistoryId_1, updateWorkQuestionHistoryDetailsRequest_1, ...args_1) => __awaiter(this, [workHistoryId_1, updateWorkQuestionHistoryDetailsRequest_1, ...args_1], void 0, function* (workHistoryId, updateWorkQuestionHistoryDetailsRequest, options = {}) {
            assertParamExists('addWorkQuestionHistoryDetail1', 'workHistoryId', workHistoryId);
            assertParamExists('addWorkQuestionHistoryDetail1', 'updateWorkQuestionHistoryDetailsRequest', updateWorkQuestionHistoryDetailsRequest);
            const localVarPath = `/drillweb/workHistory/{workHistoryId}/questionHistory`
                .replace(`{${"workHistoryId"}}`, encodeURIComponent(String(workHistoryId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkQuestionHistoryDetailsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const WorkQuestionHistoryDetailControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkQuestionHistoryDetailControllerApiAxiosParamCreator(configuration);
    return {
        addWorkQuestionHistoryDetail(workHistoryId, addWorkQuestionHistoryDetailsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addWorkQuestionHistoryDetail(workHistoryId, addWorkQuestionHistoryDetailsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkQuestionHistoryDetailControllerApi.addWorkQuestionHistoryDetail']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        addWorkQuestionHistoryDetail1(workHistoryId, updateWorkQuestionHistoryDetailsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addWorkQuestionHistoryDetail1(workHistoryId, updateWorkQuestionHistoryDetailsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkQuestionHistoryDetailControllerApi.addWorkQuestionHistoryDetail1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const WorkQuestionHistoryDetailControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkQuestionHistoryDetailControllerApiFp(configuration);
    return {
        addWorkQuestionHistoryDetail(workHistoryId, addWorkQuestionHistoryDetailsRequest, options) {
            return localVarFp.addWorkQuestionHistoryDetail(workHistoryId, addWorkQuestionHistoryDetailsRequest, options).then((request) => request(axios, basePath));
        },
        addWorkQuestionHistoryDetail1(workHistoryId, updateWorkQuestionHistoryDetailsRequest, options) {
            return localVarFp.addWorkQuestionHistoryDetail1(workHistoryId, updateWorkQuestionHistoryDetailsRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class WorkQuestionHistoryDetailControllerApi extends BaseAPI {
    addWorkQuestionHistoryDetail(workHistoryId, addWorkQuestionHistoryDetailsRequest, options) {
        return WorkQuestionHistoryDetailControllerApiFp(this.configuration).addWorkQuestionHistoryDetail(workHistoryId, addWorkQuestionHistoryDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    addWorkQuestionHistoryDetail1(workHistoryId, updateWorkQuestionHistoryDetailsRequest, options) {
        return WorkQuestionHistoryDetailControllerApiFp(this.configuration).addWorkQuestionHistoryDetail1(workHistoryId, updateWorkQuestionHistoryDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const WorkTemplateControllerApiAxiosParamCreator = function (configuration) {
    return {
        getWorkTemplateById: (courseId_1, templateGroupId_1, id_1, ...args_1) => __awaiter(this, [courseId_1, templateGroupId_1, id_1, ...args_1], void 0, function* (courseId, templateGroupId, id, options = {}) {
            assertParamExists('getWorkTemplateById', 'courseId', courseId);
            assertParamExists('getWorkTemplateById', 'templateGroupId', templateGroupId);
            assertParamExists('getWorkTemplateById', 'id', id);
            const localVarPath = `/drillweb/work/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }
            if (templateGroupId !== undefined) {
                localVarQueryParameter['templateGroupId'] = templateGroupId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getWorkTemplateGroupList: (courseId_1, ...args_1) => __awaiter(this, [courseId_1, ...args_1], void 0, function* (courseId, options = {}) {
            assertParamExists('getWorkTemplateGroupList', 'courseId', courseId);
            const localVarPath = `/drillweb/work/template/group`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const WorkTemplateControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkTemplateControllerApiAxiosParamCreator(configuration);
    return {
        getWorkTemplateById(courseId, templateGroupId, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkTemplateById(courseId, templateGroupId, id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkTemplateControllerApi.getWorkTemplateById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        getWorkTemplateGroupList(courseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkTemplateGroupList(courseId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['WorkTemplateControllerApi.getWorkTemplateGroupList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const WorkTemplateControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkTemplateControllerApiFp(configuration);
    return {
        getWorkTemplateById(courseId, templateGroupId, id, options) {
            return localVarFp.getWorkTemplateById(courseId, templateGroupId, id, options).then((request) => request(axios, basePath));
        },
        getWorkTemplateGroupList(courseId, options) {
            return localVarFp.getWorkTemplateGroupList(courseId, options).then((request) => request(axios, basePath));
        },
    };
};
export class WorkTemplateControllerApi extends BaseAPI {
    getWorkTemplateById(courseId, templateGroupId, id, options) {
        return WorkTemplateControllerApiFp(this.configuration).getWorkTemplateById(courseId, templateGroupId, id, options).then((request) => request(this.axios, this.basePath));
    }
    getWorkTemplateGroupList(courseId, options) {
        return WorkTemplateControllerApiFp(this.configuration).getWorkTemplateGroupList(courseId, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map